/**
 * 集中管理所有store导出
 */

// 导入所有store
import { useUserStore } from './user'
import { useAppStore } from './app'
import { useParkStore } from './park'
import { useReportStore } from './report'
import { useServiceStore } from './service'

// 用于获取和初始化所有store（可在应用启动时调用）
export const initializeStores = () => ({
  user: useUserStore(),
  app: useAppStore(),
  park: useParkStore(),
  report: useReportStore(),
  service: useServiceStore(),
})

// 导出所有store
export {
  useUserStore,
  useAppStore,
  useParkStore,
  useReportStore,
  useServiceStore,
} 